<div *ngIf="checkViewMode('edit')"
  [class]="'form-group txt_'+getOptionByKey(attribute,'identifier')">
  <label for="">
    {{ showTitle ? getTitle() : '' }}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')"
      class="popover-info"
      [popover]="getOptionByKey(attribute,'tooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <input class="form-control m-input"
    [class.has-error]="attribute.hasError"
    [(ngModel)]="value"
    [disabled]="getBooleanOptionByKey(attribute,'disabled')"
    [maxlength]="getOptionByKey(attribute,'maxlength')"
    [placeholder]="getPlaceholder(attribute)"
    [required]="getBooleanOptionByKey(attribute,'required')"
    [type]="getInputType(attribute)"
    [tabindex]="getOptionByKey(attribute,'tabIndex')"
    (blur)="onBlurInput()"
    (input)="onInputHandler($event)"
    [mask]="getMask(true)"
    [prefix]="getPrefix()">
</div>

<div *ngIf="checkViewMode('view')">
  <p class="component-view"><span>{{ getTitle() }}: </span> {{ getValueForView() }}</p>
  <div *ngIf="getOptionByKey(attribute,'viewtooltip')" 
      class="popover-info" 
      [popover]="getOptionByKey(attribute,'viewtooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
    <i class="fa fa-question-circle"></i>
  </div>
</div>